/**
 * @param {String} name [储存的名字]
 * @param {String} content [储存的值]
 */
/**
 * 存储localStorage
 */

const localstorage = {
  setStore(name, content) {
    if (!name) return;
    if (typeof content !== 'string') {
      content = JSON.stringify(content);
    }
    window.localStorage.setItem(name, content);
  },

  /**
     * 获取localStorage
     */
  getStore(name) {
    if (!name) return;
    return window.localStorage.getItem(name);
  },

  /**
     * 删除localStorage
     */
  removeStore(name) {
    if (!name) return;
    window.localStorage.removeItem(name);
  }
};

export default localstorage;
